// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__9uNfM","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3E1np"};